import React from 'react';
import { RadioOption, RadioProps } from '..';
import { Button as ButtonBaseComponent } from '@/components/ui/Button';
import { useCustomComponent } from '@/hooks';

export interface RadioButtonProps extends RadioProps {
  isSelected: boolean;
  option: RadioOption;
  onClick: () => void;
}

export const ButtonComponent: React.FC<RadioButtonProps> = ({
  isSelected,
  disabled,
  onClick,
  option,
}) => {
  return (
    <ButtonBaseComponent
      variant={isSelected ? 'primary' : 'neutral-secondary-900'}
      disabled={disabled || option.disabled}
      onClick={onClick}
    >
      {option.label}
    </ButtonBaseComponent>
  );
};

export const Button: React.FC<RadioButtonProps> = (props: RadioButtonProps) => {
  const Component = useCustomComponent({
    componentName: 'RadioButton',
    Component: ButtonComponent,
  });

  return <Component {...props} />;
};
